var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.25C13.4142 1.25 13.75 1.58579 13.75 2V7C13.75 7.41421 13.4142 7.75 13 7.75C12.5858 7.75 12.25 7.41421 12.25 7V2C12.25 1.58579 12.5858 1.25 13 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25C11.5858 9.25 11.25 9.58579 11.25 10C11.25 10.4142 11.5858 10.75 12 10.75H22C22.4142 10.75 22.75 10.4142 22.75 10C22.75 9.58579 22.4142 9.25 22 9.25H12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.111 21.2862C14.6039 22.1804 11.9057 22.2344 9.37549 21.4485C9.45629 21.1855 9.5 20.9044 9.5 20.6125V15.2628C9.5 14.9969 9.46373 14.7401 9.39619 14.4976C11.2132 13.9631 13.1183 13.8574 14.9795 14.1892L15.549 14.2908C16.317 14.4278 16.8929 15.0065 17.1179 15.7248L14.7437 16.6486C14.3544 16.8 14.1536 17.2604 14.2952 17.6769C14.4367 18.0934 14.867 18.3083 15.2563 18.1568L17.6228 17.2361L19.9824 16.605C21.0073 16.3308 22 17.1602 22 18.2904C22 19.0382 21.5528 19.7021 20.8897 19.9386L17.111 21.2862Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.2628C2 14.6719 2.44772 14.1929 3 14.1929H7C7.55228 14.1929 8 14.6719 8 15.2628V20.6125C8 21.2034 7.55228 21.6824 7 21.6824H3C2.44772 21.6824 2 21.2034 2 20.6125V15.2628Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.25C17.4142 4.25 17.75 4.58579 17.75 5V7C17.75 7.41421 17.4142 7.75 17 7.75C16.5858 7.75 16.25 7.41421 16.25 7V5C16.25 4.58579 16.5858 4.25 17 4.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 3C21.75 2.58579 21.4142 2.25 21 2.25C20.5858 2.25 20.25 2.58579 20.25 3V7C20.25 7.41421 20.5858 7.75 21 7.75C21.4142 7.75 21.75 7.41421 21.75 7V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandChart);
export default __webpack_public_path__ + "static/media/hand-chart.a404084724cc61c7c85d263bdeb7978e.svg";
export { ForwardRef as ReactComponent };